import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import validate from "validate.js";
import Select from "react-select";
import { isEmpty } from "lodash";
import { Button, Row, Col, Form } from "react-bootstrap";
import { PageHeader, FormFieldLabel } from "CommonComponent";
import AccessRights from "utils/AccessRights";
import {
  saveRolesAccess,
  hideRolesAccessValidationError,
  rolesListFetch,
  objectsNestedTreeFetch,
  permissionsByRoleFetch,
  setPermissionFetchedFalse,
  objectsListFetch,
} from "../actions";
import { NestedObjects } from "./component";
import "./RoleAccess.css";

const schema = {
  role_id: {
    presence: { allowEmpty: false, message: "^Please select role" },
  },
};

const RoleAccess = (props) => {
  const dispatch = useDispatch();
  const session = useSelector((state) => state.session || {});
  const rolesAccessState = useSelector((state) => state.rolesAccessState || {});
  const rolesState = useSelector((state) => state.rolesState?.rolesList || []);
  const objectsState = useSelector((state) => state.objectsState || {});

  const [formValid, setFormValid] = useState(false);
  const [RoleValue, setRoleValue] = useState(null);
  const [ReloadTree, setReloadTree] = useState(false);
  const [initialRoles, setInitialRoles] = useState([]);
  const [formState, setFormState] = useState({
    isValid: false,
    values: {
      role_access_rights: {},
      object_viewed_id: "",
    },
    touched: { object_viewed_id: true },
    errors: {},
  });

  useEffect(() => {
    dispatch(objectsNestedTreeFetch(""));
    dispatch(objectsListFetch(""));
    dispatch(rolesListFetch());
  }, [dispatch]);

  useEffect(() => {
    if (rolesState.length) {
      const roles = rolesState.map((role) => ({
        label: role.name,
        value: role.id,
      }));
      setInitialRoles(roles);
    }
  }, [rolesState]);

  useEffect(() => {
    if (rolesAccessState.isPermissonsFetched) {
      setReloadTree(true);
      dispatch(setPermissionFetchedFalse());
    }
  }, [rolesAccessState.isPermissonsFetched, dispatch]);

  useEffect(() => {
    const errors = validate(formState.values, schema);
    setFormState((prevState) => ({
      ...prevState,
      isValid: !errors,
      errors: errors || {},
    }));
  }, [formState.values]);

  useEffect(() => {
    if (!isEmpty(rolesAccessState.validation_error)) {
      const errors = rolesAccessState.validation_error;
      setFormState((prevState) => ({
        ...prevState,
        isValid: !errors,
        errors: errors || {},
      }));
    }
  }, [rolesAccessState.validation_error]);

  const setRolesId = (role_id) => {
    setFormState((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        role_id: role_id,
        role_access_rights: {},
      },
      touched: {
        ...prevState.touched,
        role_id: true,
      },
    }));

    if (role_id) {
      dispatch(permissionsByRoleFetch(role_id));
    }
    setReloadTree(false);
  };

  const handleChange = (event) => {
    const { name, value, checked, type } = event.target;
    setFormState((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        [name]: type === "checkbox" ? checked : value,
      },
      touched: { ...prevState.touched, [name]: true },
    }));
    dispatch(hideRolesAccessValidationError(name));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    await dispatch(saveRolesAccess(formState.values));
  };

  const hasError = (field) =>
    formState.touched[field] && formState.errors[field] ? true : false;

  const customStyles = {
    control: (provided) => ({
      ...provided,
      borderRadius: "60px",
      border: "1px solid #ccc",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#aaa",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#000",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#666",
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: "#fff",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#f0f0f0" : "#fff",
      color: "#000",
    }),
  };

  return (
    <>
      <PageHeader title="Add Roles Access" />
      <div className="main-content-div">
        <div className="add-role">
          <Row className="mb-4">
            <Col lg={4}>
              <FormFieldLabel required>Select Role</FormFieldLabel>
              <Select
                aria-label="Select Roles"
                className="multi-select w-100"
                placeholder="Select Roles"
                isSearchable={true}
                value={RoleValue}
                styles={customStyles}
                onChange={(newValue) => {
                  if (newValue) {
                    setRoleValue(newValue);
                    setRolesId(newValue.value);
                  } else {
                    setRoleValue(null);
                    setRolesId("");
                  }
                }}
                options={initialRoles}
              />
            </Col>
          </Row>

          <div className="add-role-access">
            {!isEmpty(objectsState.objectsNestedTree) && ReloadTree ? (
              <NestedObjects
                component="nav"
                key={"nested_menu"}
                objectLists={objectsState.objectsNestedTree}
                setFormState={setFormState}
                formState={formState}
              />
            ) : null}
          </div>

          {!isEmpty(RoleValue) ? (
            <div className="d-flex justify-content-end gap-4">
              <button
                className="n-u-btn"
                onClick={handleSubmit}
                disabled={!formState.isValid}
              >
                Save
              </button>
              <button
                onClick={props.onHide}
                className="c-b-btn"
              >
                Cancel
              </button>
            </div>
          ) : null}
        </div>
      </div>
    </>
  );
};

export default RoleAccess;
